module.exports = __webpack_public_path__ + "img/unam-cieg.a9899673.png";